import { Api } from 'models/services/api';
import { DeleteStoreQuery } from 'models/services/graphql';

import { StoreData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteStore($id: ID!) {
    ${DeleteStoreQuery}
  }
`;

type ResponseData = {
  data: {
    deleteStore: StoreData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: StoreData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.deleteStore;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };